import { MetadataFilterEditor } from "@/components/filters/MetadataFilterEditor"

import { useRunsFilter } from "../../contexts/RunsFilterContext"

/** Server-side metadata predicates for every page of runs and simulations. */
export function RunsMetadataFilterSection() {
  const { metadataFilters = [], setMetadataFilters } = useRunsFilter()
  return (
    <MetadataFilterEditor
      trimScalarDraft
      scalarMaxLength={1000}
      filters={metadataFilters}
      onAddFilter={(filter) => setMetadataFilters([...metadataFilters, filter])}
      onChangeFilters={setMetadataFilters}
    />
  )
}
